import { Flex, Text } from '@mantine/core'
import React from 'react'

import { type CoreInquiry } from '@flecto/types'

export type CellOwnerProps = {
  inquiry?: CoreInquiry
}

export function CellOwner({ inquiry }: CellOwnerProps) {
  return (
    <Flex style={{ overflow: 'hidden' }} direction='column'>
      <Text fw={500} truncate>
        {inquiry?.full_name}
      </Text>
      <Text color='dimmed' size='sm' truncate>
        {inquiry?.email}
      </Text>
      <Text color='dimmed' size='sm' truncate>
        {inquiry?.phone_number}
      </Text>
    </Flex>
  )
}
